import { documentService, windowService } from './window.utils.js';
import printPrivacyStatementStyles from './PrintPrivacyStatementStyles.js';
const generatePDF = (): void => {
    const clearTableStylesTag = (): void => {
        const styledTag = documentService()?.getElementById('privacy-statement-v2-print-styles');
        if (styledTag) {
            styledTag.parentElement.removeChild(styledTag);
        }
    };

    clearTableStylesTag();
    const style = documentService().createElement('style');
    style.setAttribute('id', 'privacy-statement-v2-print-styles');
    style.setAttribute('rel', 'stylesheet');
    style.setAttribute('type', 'text/css');
    style.setAttribute('media', 'print');
    style.appendChild(documentService().createTextNode(printPrivacyStatementStyles()));
    documentService().head.appendChild(style);

    // Note: For some crazy reason window.print is not a blocking command when the page freshly load without cache
    // As a temporary fix adding eventListeners for after print
    /** afterprint event is replaced with focus event as afterprint is triggered even before the print operation
     *  is started in some mobile devices 
    */
    windowService().addEventListener('focus', clearTableStylesTag, { once: true });
    if (windowService().print) {
        windowService().print();
    }
}

export { generatePDF }